import { GridColDef } from "@mui/x-data-grid-pro";
import { IconButton } from "@mui/material";
import { CustomRadioGroupInput } from "../components/custom_radio_group_input";
import { DefaultTableDatePickerInput } from "../../../../../../common/components/default_table_date_picker_input";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import ButtonOcorrencia from "../components/button_ocorrencia";
import dayjs from "dayjs";
import { GetAllAtributosObrasCadastroResponse } from "../../../../data/daos/read/get_all_atributos_obras_cadastro";

/**
 * GenerateInspecaoObraItensColumnsDefinition
 */

type Props = {
  atributoObras: GetAllAtributosObrasCadastroResponse | null;
  statusChecklistServico: number | null;
  lockInspecaoObraItens: boolean | undefined;
  onActionOcorrencia: (idInformacoesInspecaoObra: number | null, idInspecaoObraItens: number, openState: boolean, fillData?: boolean) => void;
  onActionInspecao1Change: (idInspecaoObraItens: number, value: string | number | null) => void;
  onActionDataInspecao1Change: (idInspecaoObraItens: number, value: Date | null) => void;
  onActionInspecao2Change: (idInspecaoObraItens: number, value: string | number | null) => void;
  onActionDataInspecao2Change: (idInspecaoObraItens: number, value: Date | null) => void;
  onActionLimpar: (idInspecaoObraItem: number) => void;
};

export const GenerateInspecaoObraItensColumnsDefinition = ({
  atributoObras,
  statusChecklistServico,
  lockInspecaoObraItens,
  onActionOcorrencia,
  onActionInspecao1Change,
  onActionDataInspecao1Change,
  onActionInspecao2Change,
  onActionDataInspecao2Change,
  onActionLimpar,
}: Props): GridColDef[] => {
  const inspecao1Options = [
    {
      id: "N",
      label: "NA",
      style: {
        backgroundColor: "#89c4f4",
        color: "white",
        padding: ".2rem .4rem",
        fontSize: "0.65rem",
        fontWeight: 700,
        textShadow: "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
        borderRadius: "50px",
      },
    },
    {
      id: "A",
      label: "A",
      style: {
        backgroundColor: "#45b6af",
        color: "white",
        padding: ".2rem .4rem",
        fontSize: "0.65rem",
        fontWeight: 700,
        textShadow: "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
        borderRadius: "50px",
      },
    },
    {
      id: "R",
      label: "R",
      style: {
        backgroundColor: "#f8cb00",
        color: "white",
        padding: ".2rem .4rem",
        fontSize: "0.65rem",
        fontWeight: 700,
        textShadow: "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
        borderRadius: "50px",
      },
    },
    {
      id: "X",
      label: "X",
      style: {
        backgroundColor: "#f3565d",
        color: "white",
        padding: ".2rem .4rem",
        fontSize: "0.65rem",
        fontWeight: 700,
        textShadow: "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
        borderRadius: "50px",
      },
    },
  ];

  const inspecao2Options = [
    {
      id: "A",
      label: "RA",
      style: {
        backgroundColor: "#45b6af",
        color: "white",
        padding: ".2rem .4rem",
        fontSize: "0.65rem",
        fontWeight: 700,
        textShadow: "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
        borderRadius: "50px",
      },
    },
    {
      id: "X",
      label: "X",
      style: {
        backgroundColor: "#f3565d",
        color: "white",
        padding: ".2rem .4rem",
        fontSize: "0.65rem",
        fontWeight: 700,
        textShadow: "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
        borderRadius: "50px",
      },
    },
  ];

  const columns: GridColDef[] = [
    {
      field: "metodoVerificacao",
      filterable: false,
      headerName: "Método de Verificação",
      flex: 2,
      minWidth: 150,
      sortable: false,
      headerClassName: 'funcionarios-header',
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex items-center text-xs py-2">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "tolerancia",
      filterable: false,
      headerName: "Tolerância",
      width: 100,
      minWidth: 100,
      sortable: false,
      headerClassName: 'funcionarios-header',
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex items-center text-xs py-2">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "novaOcorrencia",
      filterable: false,
      headerName: "",
      minWidth: 80,
      width: 80,
      sortable: false,
      headerClassName: "funcionarios-header",
      valueGetter: (_, row) => row["idInspecaoObraItem"],
      renderCell: ({ value }) => {
        if (value === null || value === undefined) return null;
        return (
          <div className="h-full flex justify-center items-center">
            <ButtonOcorrencia
              buttonColor="red"
              disabled={lockInspecaoObraItens || statusChecklistServico === 1}
              onClick={() => onActionOcorrencia(null, value, true, true)}
              startIcon={<DynamicIcon nameIcon="Add" size={7} className="text-white" />}>
              NC
            </ButtonOcorrencia>
          </div>
        );
      },
    },
    {
      field: "inspecao1",
      filterable: false,
      headerName: "1ª Inspeção",
      minWidth: 220,
      width: 220,
      sortable: false,
      valueGetter: (_, row) => ({ idInspecaoObraItem: row["idInspecaoObraItem"], inspecao1: row["inspecao1"] }),
      renderCell: ({ value }) => {
        if (value.idInspecaoObraItem === null || value.idInspecaoObraItem === undefined) return null;
        return (
          <div className="w-full h-full flex justify-center items-center">
            <CustomRadioGroupInput
              name="inspecao1"
              options={inspecao1Options}
              value={value.inspecao1}
              readOnly={lockInspecaoObraItens || statusChecklistServico === 1}
              onValueChange={(v) => onActionInspecao1Change(value.idInspecaoObraItem, v)}
            />
          </div>
        );
      },
    },
    {
      field: "dataInspecao1",
      filterable: false,
      headerName: "Data",
      minWidth: 125,
      width: 125,
      sortable: false,
      valueGetter: (_, row) => ({ idInspecaoObraItem: row["idInspecaoObraItem"], dataInspecao1: row["dataInspecao1"] }),
      renderCell: ({ value }) => {
        if (value.idInspecaoObraItem === null || value.idInspecaoObraItem === undefined) return null;
        return (
          <div className="w-[6.5rem] h-full flex items-center justify-center">
            <DefaultTableDatePickerInput
              sx={{
                '&.MuiFormControl-root.MuiPickersTextField-root': {
                  '.MuiPickersInputBase-root.MuiPickersOutlinedInput-root': {
                    '.MuiPickersSectionList-root.MuiPickersInputBase-sectionsContainer': {
                      fontSize: '0.75rem'
                    },
                    paddingLeft: '0.60rem',
                    paddingRight: '0.60rem',
                  },
                },
              }}
              value={value.dataInspecao1}
              readOnly={lockInspecaoObraItens || statusChecklistServico === 1}
              onChange={(e) => onActionDataInspecao1Change(value.idInspecaoObraItem, e)}
            />
          </div>
        );
      },
    },
    {
      field: "usuarioRegistradoPorInspecao1",
      filterable: false,
      headerName: "Registrado Por",
      width: 120,
      minWidth: 120,
      sortable: false,
      valueGetter: (_, row) => ({
        usuarioRegistradoPorInspecao1: row['usuarioRegistradoPorInspecao1'],
        dataRegistradoPorInspecao1: row['dataRegistradoPorInspecao1'],
      }),
      renderCell: ({ value }) => (
        <div className="w-full h-full py-2 flex flex-col items-center text-[0.65rem]">
          <span>{value.usuarioRegistradoPorInspecao1}</span>
          <span>{value.dataRegistradoPorInspecao1 && dayjs.utc(value.dataRegistradoPorInspecao1).local().format('DD/MM/YYYY')}</span>
        </div>
      ),
    },
    {
      field: "inspecao2",
      filterable: false,
      headerName: "2ª Inspeção",
      minWidth: 125,
      width: 125,
      sortable: false,
      valueGetter: (_, row) => ({
        idInspecaoObraItem: row["idInspecaoObraItem"],
        inspecao1: row["inspecao1"],
        inspecao2: row["inspecao2"],
      }),
      renderCell: ({ value }) => {
        if (value.idInspecaoObraItem === null || value.idInspecaoObraItem === undefined) return null;
        return (
          <div className="w-full h-full flex justify-center items-center">
            <CustomRadioGroupInput
              name="inspecao2"
              options={inspecao2Options}
              disabled={value.inspecao1 !== "R"}
              value={value.inspecao2}
              readOnly={lockInspecaoObraItens || statusChecklistServico === 1}
              onValueChange={(v) => onActionInspecao2Change(value.idInspecaoObraItem, v)}
            />
          </div>
        );
      },
    },
    {
      field: "dataInspecao2",
      filterable: false,
      headerName: "Data",
      minWidth: 125,
      width: 125,
      sortable: false,
      valueGetter: (_, row) => ({
        idInspecaoObraItem: row["idInspecaoObraItem"],
        inspecao1: row["inspecao1"],
        dataInspecao2: row["dataInspecao2"],
      }),
      renderCell: ({ value }) => {
        if (value.idInspecaoObraItem === null || value.idInspecaoObraItem === undefined) return null;
        return (
          <div className="w-[6.5rem] h-full flex items-center justify-center">
            <DefaultTableDatePickerInput
              sx={{
                '&.MuiFormControl-root.MuiPickersTextField-root': {
                  '.MuiPickersInputBase-root.MuiPickersOutlinedInput-root': {
                    '.MuiPickersSectionList-root.MuiPickersInputBase-sectionsContainer': {
                      fontSize: '0.75rem'
                    },
                    paddingLeft: '0.60rem',
                    paddingRight: '0.60rem',
                  },
                },
              }}
              disabled={value.inspecao1 !== "R"}
              value={value.dataInspecao2}
              readOnly={lockInspecaoObraItens || statusChecklistServico === 1}
              onChange={(e) => onActionDataInspecao2Change(value.idInspecaoObraItem, e)}
            />
          </div>
        );
      },
    },
    {
      field: "usuarioRegistradoPorInspecao2",
      filterable: false,
      headerName: "Registrado Por",
      width: 120,
      minWidth: 120,
      sortable: false,
      valueGetter: (_, row) => ({
        usuarioRegistradoPorInspecao2: row['usuarioRegistradoPorInspecao2'],
        dataRegistradoPorInspecao2: row['dataRegistradoPorInspecao2'],
      }),
      renderCell: ({ value }) => (
        <div className="w-full h-full py-2 flex flex-col items-center text-[0.65rem]">
          <span>{value.usuarioRegistradoPorInspecao2}</span>
          <span>{value.dataRegistradoPorInspecao2 && dayjs.utc(value.dataRegistradoPorInspecao2).local().format('DD/MM/YYYY')}</span>
        </div>
      ),
    },
    {
      field: "limpar",
      sortable: false,
      filterable: false,
      headerName: "Limpar",
      width: 55,
      valueGetter: (_, row) => row["idInspecaoObraItem"] as number,
      renderCell: (params) => {
        if (params.value === null || params.value === undefined) return null;
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              onClick={() => {
                if (!lockInspecaoObraItens && statusChecklistServico !== 1) onActionLimpar(params.value);
              }}>
              <DynamicIcon nameIcon="CleaningServices" size={20} className="text-[#f8cb00]" />
            </IconButton>
          </div>
        );
      },
    },
  ];

  return columns.filter(column => (
    (atributoObras && atributoObras.exibirDataInspecao === true) || (
      (column.field !== "usuarioRegistradoPorInspecao1" &&
        column.field !== "usuarioRegistradoPorInspecao2")
    )
  ));
};
